export const projects = [
  {
    title: "GYM Body Builder",
    subtitle: "Tailwind and HTML",
    description: "This Project was mainly build with Tailwind CSS.",
    image: "./project-1.gif",
    link: "https://blessja.github.io/gym1/",
  },
  {
    title: "Social Media App front-end",
    subtitle: "React and Bootstrap 5",
    description:
      "The project focuses on the front-end of social media app UI components",
    image: "./mern-front-end.gif",
    link: "https://mern-front-seven.vercel.app/",
  },
  {
    title: "Social Media App ",
    subtitle: "Mern Stack Framework",
    description:
      "Social media app, with features to post a comment, like comment and comments. ",
    image: "./mern.gif",
    link: "https://mern-social-five.vercel.app/login",
  },
  {
    title: "Progress bar",
    subtitle: "HTML, CSS & JAVASCRIPT",
    description: "This is a pure vanilla html, css & javascript project.",
    image: "./project-4.gif",
    link: "https://blessja.github.io/Progress-steps/",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Express js",
  "Node",
  "Ruby on Rails",
  "Material UI",
  "HTML5",
  "CSS3",
];



// WEBPACK FOOTER //
// ./src/data.js